import { useContext } from 'react';
import { CalendarAppContext } from './context';

export const useCalendarApp = () => {
  const context = useContext(CalendarAppContext);

  if (!context) throw new Error('useCalendarApp must be used within a CalendarAppProvider');

  return context;
};
